export const en = {
    lang: 'en',
    highFrequency: [
        'the',
        'be',
        'to',
        'of',
        'and',
        'a',
        'in',
        'that',
        'have',
        'i',
        'it',
        'for',
        'not',
        'on',
        'with',
        'he',
        'as',
        'you',
        'do',
        'at',
        'this',
        'but',
        'his',
        'by',
        'from',
        'they',
        'we',
        'her',
        'she',
        'or',
        'an',
        'will',
        'my',
        'one',
        'all',
        'would',
        'there',
        'their',
        'what',
        'so',
        'up',
        'out',
        'if',
        'about',
        'who',
        'get',
        'which',
        'go',
        'me',
        'when',
        'make',
        'can',
        'like',
        'no',
        'just',
        'him',
        'know',
        'take',
        'how',
        'come',
        'could',
        'them',
        'see',
        'than',
        'now',
        'look',
        'only',
        'its',
        'over',
        'think',
        'also',
        'back',
        'use',
        'two',
        'way',
        'well',
        'then',
        'did',
        'been',
        'had',
        'are',
        'is',
        'was',
        'were',
        'am',
    ],
    stickForward: [
        'a',
        'an',
        'the',
        'in',
        'on',
        'at',
        'to',
        'for',
        'with',
        'by',
        'from',
        'of',
        'and',
        'or',
        'but',
        'is',
        'are',
        'was',
        'were',
        'not',
        'no',
    ],
    stickBackward: [],
    highFreqGateClusters: 3,
};
//# sourceMappingURL=en.js.map